export const MAX_TOTAL_GUESTS = 12
export const MIN_ADULTS = 1
export const MIN_CHILDREN = 0
export const MIN_PETS = 0
export const MAX_ADULTS = 12
export const MAX_CHILDREN = 12
export const MAX_PETS = 12
